export var FrictionsNames;
(function (FrictionsNames) {
    FrictionsNames["RC"] = "rageClick";
    FrictionsNames["QB"] = "qualifiedBouncers";
    FrictionsNames["MHR"] = "multiplePageRevisit";
    FrictionsNames["MCR"] = "multiplePageRevisit";
    FrictionsNames["MBI"] = "multipleButtonInteraction";
    FrictionsNames["MFI"] = "multipleFieldInteraction";
    FrictionsNames["LT"] = "loadingTime";
})(FrictionsNames || (FrictionsNames = {}));
export var FrustrationScoreFrictionsNames;
(function (FrustrationScoreFrictionsNames) {
    FrustrationScoreFrictionsNames["RageClick"] = "RAGE_CLICK";
    FrustrationScoreFrictionsNames["MultipleUseTarget"] = "MULTIPLE_USE_TARGET";
    FrustrationScoreFrictionsNames["LowActivity"] = "LOW_ACTIVITY";
    FrustrationScoreFrictionsNames["AnyJsError"] = "ANY_JS_ERROR";
    FrustrationScoreFrictionsNames["JsErrorAfterClick"] = "JS_ERROR_AFTER_CLICK";
    FrustrationScoreFrictionsNames["ExcessiveHover"] = "EXCESSIVE_HOVER";
    FrustrationScoreFrictionsNames["MultipleButtonInterractions"] = "MULTIPLE_BUTTON_INTERACTIONS";
    FrustrationScoreFrictionsNames["MultipleFieldInterractions"] = "MULTIPLE_FIELD_INTERACTIONS";
    FrustrationScoreFrictionsNames["LoadingTime"] = "LOADING_TIME";
    FrustrationScoreFrictionsNames["PageNotConsumed"] = "PROP_VIEWS_NOT_CONSUMED";
    FrustrationScoreFrictionsNames["PageLooping"] = "LOOPING_INDEX";
    FrustrationScoreFrictionsNames["AnyApiError"] = "ANY_API_ERROR";
    FrustrationScoreFrictionsNames["ApiErrorAfterClick"] = "API_ERROR_AFTER_CLICK";
})(FrustrationScoreFrictionsNames || (FrustrationScoreFrictionsNames = {}));
export const FrustrationScoreFrictionsIcons = {
    [FrustrationScoreFrictionsNames.RageClick]: 'click-rage',
    [FrustrationScoreFrictionsNames.MultipleUseTarget]: 'multiple-clicks-link',
    [FrustrationScoreFrictionsNames.LowActivity]: 'low-activity',
    [FrustrationScoreFrictionsNames.AnyJsError]: 'error-script',
    [FrustrationScoreFrictionsNames.JsErrorAfterClick]: 'error-script-after-click',
    [FrustrationScoreFrictionsNames.ExcessiveHover]: 'excessive-hover',
    [FrustrationScoreFrictionsNames.MultipleButtonInterractions]: 'multiple-clicks-button',
    [FrustrationScoreFrictionsNames.MultipleFieldInterractions]: 'multiple-clicks-field',
    [FrustrationScoreFrictionsNames.LoadingTime]: 'slow-loading-time',
    [FrustrationScoreFrictionsNames.PageNotConsumed]: 'page-not-consumed',
    [FrustrationScoreFrictionsNames.PageLooping]: 'page-looping',
    [FrustrationScoreFrictionsNames.AnyApiError]: 'error-script',
    [FrustrationScoreFrictionsNames.ApiErrorAfterClick]: 'error-script-after-click',
};
//# sourceMappingURL=auto-insight.model.js.map